<div class="row">
    <div class="col-md-12">
        <app-business-account-form
            *ngIf="businessAccount"
            [countries]="countries"
            [isBusinessAccountEditable]="isBusinessAccountEditable"
            [formGroup]="userForm"
            [submitted]="submitted"
        ></app-business-account-form>
    </div>
    <div class="col-md-12">
        <div class="form-group">
            <button
                type="button"
                name="confirmationYesBtn"
                class="btn btn-primary"
                (click)="onSubmit()"
            >Save</button>
        </div>
    </div>
</div>
